import DibsStorage, { localStorage, sessionStorage } from '../src/BrowserStorage.ts';
export { localStorage, sessionStorage };
export default DibsStorage;
